import { Loading } from 'element-ui'

let loadingInstance
let requestCount = 0 // Track concurrent requests
let loadingTimer = null
const LOADING_DELAY = 300 // ms – avoid flash for very quick requests

export const showLoading = () => {
    requestCount++

    // Only consider showing loading indicator for the first active request
    if (requestCount === 1 && !loadingInstance && !loadingTimer) {
        loadingTimer = setTimeout(() => {
            loadingInstance = Loading.service({
                lock: true,
                text: 'Hệ thống đang tải dữ liệu ...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            loadingTimer = null
        }, LOADING_DELAY)
    }
}

export const hideLoading = () => {
    if (requestCount <= 0) {
        requestCount = 0
        return
    }

    requestCount--

    // When no more active requests, cancel pending timer or hide overlay
    if (requestCount === 0) {
        if (loadingTimer) {
            clearTimeout(loadingTimer)
            loadingTimer = null
        }

        if (loadingInstance) {
            loadingInstance.close()
            loadingInstance = null
        }
    }
}
